<header class="flex h-16 bg-white">
  <button
    class="inline-flex size-16 items-center justify-center bg-brand-primary-pure text-white transition-all duration-150 hover:bg-brand-primary-dark hover:text-brand-primary-lightest md:hidden"
    tabindex="0"
    (click)="toggleMenuCollapse.emit()"
  >
    <ng-icon name="featherMenu" size="32" />
  </button>

  <div
    class="flex flex-1 items-center justify-between border-b border-solid border-[#F0E3D4] px-4 py-2 lg:px-6"
  >
    <img
      src="assets/images/my-world-logo.webp"
      alt="Logo Meu Mundo"
      class="w-28 object-contain"
    />

    <div class="flex gap-4">
      @if (shopIsAvailable()) {
        <button
          aria-label="Abrir carrinho de compras"
          (click)="handleOpenCartDrawer()"
          class="relative flex size-10 items-center justify-center rounded-full border border-transparent p-1 text-brand-primary-pure transition-colors duration-150 hover:border-brand-primary-lighter hover:bg-brand-primary-lightest hover:text-brand-primary-dark hover:shadow-sm"
        >
          <span
            class="absolute right-0 top-0 flex size-4 items-center justify-center overflow-hidden rounded-full bg-feedback-success-medium text-xs font-semibold text-white shadow-sm"
            >{{ uniqueItemsCount() }}</span
          >
          <ng-icon name="featherShoppingCart" size="24" />
        </button>
      }

      <div>
        <ui-dropdown [items]="profileMenu">
          <ng-template
            #dropdownTrigger
            let-toggleExpanded="toggleExpanded"
            let-expanded="expanded"
          >
            <button
              type="button"
              class="flex items-center rounded-full text-sm transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-brand-primary-light focus:ring-offset-2"
              id="user-menu-button"
              aria-haspopup="true"
              [attr.aria-expanded]="expanded"
              (click)="toggleExpanded()"
            >
              <span class="sr-only">Open user menu</span>
              <ui-avatar [name]="studentName()" />
            </button>
          </ng-template>
        </ui-dropdown>
      </div>
    </div>
  </div>
</header>
